import React from 'react'
import { Switch, Route } from 'react-router-dom'
import {
  Introduction,
  ImageSelection,
  ImageMasking,
  InpaintingResult
} from './pages'

export const Router = () =>
  <Switch>
    <Route exact path='/' component={Introduction} />
    <Route exact path='/selection' component={ImageSelection} />
    <Route exact path='/masking' component={ImageMasking} />
    <Route exact path='/result' component={InpaintingResult} />
    <Route path='/*' component={Introduction} />
  </Switch>



// WEBPACK FOOTER //
// ./src/router.js